import React from 'react';

const Loader = ({ fullScreen = false }) => {
  return (
    <div className={`preloader ${fullScreen ? 'fullscreen' : ''}`}>
      <div className="lds-ripple">
        <div className="loader"></div>
      </div>
    </div>
  );
};

export default Loader;